import PropTypes from 'prop-types'
import React from 'react'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'

import Layout from '../components/Layout'
import Header from '../components/Cognito/Shared/Header'
import FormHeader from '../components/Cognito/Shared/FormHeader'
import Footer from '../components/Cognito/Shared/Footer'

import bgImg from '../images/login-desktop-bg.png'

import RegistrationForm from '../components/Cognito/RegistrationForm'

/**
 * Registration - page template.
 * It displays form to create user account.
 * @Tags( page, layout, unlogged-users )
 * @SuggestedTags( cognito )
 * @Routes( /partners/partner-id/register )
 */
const Registration = ({ match }) => {
  const { t } = useTranslation()
  const { partnerId } = match.params

  return (
    <Layout title={t('Registration.PageTitle')}>
      <Helmet bodyAttributes={{ class: 'authentication-page registration-page' }} />
      <div>
        <Header backTo="/" />
        <main data-testid="registration-page">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-lg">
                <div className="login-content">
                  <FormHeader title={t('Registration.form.title')} subtitle={t('Registration.form.subtitle')} />
                  <RegistrationForm partnerId={partnerId} />
                  <Footer />
                </div>
              </div>
              <div
                className="col-lg-auto d-none d-lg-block px-lg-0 image-col"
                style={{ backgroundImage: `url('${bgImg}')` }}
              ></div>
            </div>
          </div>
        </main>
      </div>
    </Layout>
  )
}

Registration.propTypes = {
  /**
   * Link match with partnerId
   */
  match: PropTypes.object.isRequired,
}

export default Registration
